const VUE_APP_API_UPLOAD_URL = document.querySelector("html").getAttribute("api_upload_url");

export default VUE_APP_API_UPLOAD_URL
